import { imageUrl } from '@helpers/image';
import CarouselProvider from '@stories/Components/Carousel/CarouselProvider/CarouselProvider';
import Connected from '@stories/Components/Carousel/Connected/Connected';
import Controls from '@stories/Components/Carousel/Controls/Controls';
import MotionTrack from '@stories/Components/Carousel/MotionTrack/MotionTrack';
import { MotionConfig } from 'framer-motion';
import * as React from 'react';
import S from './TestimonialCarousel.styles';
const TestimonialCard = ({ quote, name, company, icon }) => {
    return (React.createElement(S.Card, null,
        React.createElement(S.QuoteOpenSvg, null),
        React.createElement(S.CardQuote, null, `"${quote}"`),
        React.createElement(S.CardQuotee, { "data-has-image": icon?.src ? true : false },
            icon?.src && (React.createElement(S.QuoteeImage, { src: imageUrl(icon, { height: 48, width: 48 }), role: "presentation" })),
            React.createElement("span", null,
                React.createElement(S.QuoteeName, null, name),
                React.createElement(S.QuoteeDetail, null, company))),
        React.createElement(S.QuoteCloseSvg, null)));
};
const TestimonialCarousel = (props) => {
    return (React.createElement(MotionConfig, { transition: { duration: 0.35, ease: 'easeOut', type: 'tween' } },
        React.createElement(CarouselProvider, { count: props.items.length },
            React.createElement(S.Container, null,
                React.createElement(S.CarouselWrapper, null,
                    props.title && React.createElement(S.Title, null, props.title),
                    React.createElement(Connected, null, (carousel) => (React.createElement(MotionTrack, null, props.items.map((testimonial, i) => (React.createElement(S.Item, { key: `testimonal-${i}`, "data-active-item": carousel.activeIndex === i },
                        React.createElement(TestimonialCard, { ...testimonial }))))))),
                    props.items.length > 1 && (React.createElement(S.ControlsWrapper, null,
                        React.createElement(Controls, { paginationTitle: "Testimonials carousel controls", wrap: false }))))))));
};
export default TestimonialCarousel;
